<script>
    import { openfront } from "../stores2.js"
    import { openbehind } from "../stores3.js"

    export let group_name
    export let show_name
    export let showLength
    export let nameLength
    export let img
    export let number
    export let msg
    export let msgLength
    export let category

    let selectedInfo = {}

    const close = () => {
        openfront.set(false)
        openbehind.set(false)
    }

    const behind = () => {
        openfront.set(false)
        openbehind.set(true)
    }

    import { nightmode } from "../stores5"


    export function clickOutside(node) {
  
    const handleClick = event => {
        if (node && !node.contains(event.target) && !event.defaultPrevented) {
            node.dispatchEvent(
                new CustomEvent('click_outside', node)
            )
        }
    }

	document.addEventListener('click', handleClick, true);
  
    return {
        destroy() {
            document.removeEventListener('click', handleClick, true);
            }
	    }
    }
</script>

<div class="js-modal" class:night={$nightmode} id="modal">
    <div class="modal-front" class:modal-front-night={$nightmode} id="modal-front" use:clickOutside on:click_outside={close}>
        <div class="modal-front-img" class:modal-front-img-night={$nightmode} style="background-image:url({img})"></div>
        <div class="modal-front-title" class:modal-front-title-night={$nightmode} style="font-size:{900/(showLength+20)}px; line-height:{(900/(showLength+20))*1.2}px">{show_name}</div>
        <div class="modal-front-group-number" class:modal-front-group-number-night={$nightmode}>{number}</div>
        <div class="modal-front-group-name" class:modal-front-group-name-night={$nightmode} style="font-size:{480/(nameLength+20)}px;">{group_name.replace(/\s+/g, "")}</div>
        <p class="modal-front-group-msg" class:modal-front-group-msg-night={$nightmode} style="font-size:{1700/(msgLength+65)}px; line-height:{(1700/(msgLength+65))*1.2}px">{msg}</p>
        <div class="modal-front-group-category" class:modal-front-group-category-night={$nightmode}>{category}</div>
        <div class="modal-front-to-behind" id="to-behind"  on:click={behind}>公演情報など裏へ→</div>
        <div class="modal-front-date" class:modal-front-date-night={$nightmode}>`21 09 18 - 19</div>
        <div style="grid-area:8/3/9/4; background-color:black;" on:click={behind}></div>
        <div class="barcode" class:barcode-night={$nightmode}>
            <div style="width:3px; margin-right:2px;"></div>
            <div style="width:4px; margin-right:2px;"></div>
            <div style="width:7px; margin-right:2px;"></div>
            <div style="width:4px; margin-right:4px;"></div>
            <div style="width:3px; margin-right:2px;"></div>
            <div style="width:5px; margin-right:2px;"></div>
            <div style="width:3px; margin-right:2px;"></div>
            <div style="width:4px; margin-right:4px;"></div>
            <div style="width:5px; margin-right:2px;"></div>
            <div style="width:3px; margin-right:2px;"></div>
            <div style="width:3px; margin-right:2px;"></div>
            <div style="width:4px; margin-right:4px;"></div>
            <div style="width:6px; margin-right:2px;"></div>
            <div style="width:4px; margin-right:2px;"></div>
        </div>
    </div>
</div>


<style>
.night{
    background-color: rgba(66, 66, 66, 0.3);
}
.js-modal{
    width:100%;
    height:100%;
    position:fixed;
    top:0;
    left:0;
    background-color: rgba(100, 100, 100, 0.5);
    visibility: visible;
    opacity: 100;
    -webkit-transition: .3s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: .3s cubic-bezier(0.215, 0.61, 0.355, 1);
    z-index:10;
}
.modal-front{
    position:absolute;
    top:50%;
    left:50%;
    -webkit-transform : translate(-50%,-50%);
    transform : translate(-50%,-50%);
    -webkit-transition: transform .3s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition:transform .3s cubic-bezier(0.215, 0.61, 0.355, 1);
    background-color: #ffffff;
    width:320px;
    height:720px;
    display:grid;
    grid-template-columns:50% 40% 10%;
    grid-template-rows: 20% 10% 7.5% 7.5% 20% 15% 15% 5%;
}.modal-front-night{
    background-color: #222831;
    color:#dddddd;
}
.modal-front-img{
    background-size:contain;
    background-repeat:no-repeat;
    background-position: 50% 50%;
    width:100%;
    height:100%;
    grid-area:5/1/8/3;
    border-bottom:dashed 1px black;
    border-right:dashed 1px black;
}
.modal-front-img-night{
    border-bottom:dashed 1px #dddddd;
    border-right:dashed 1px #dddddd;
}
.modal-front-title{
    font-weight: 600;
    text-align: left;
    letter-spacing: 0.2em;
    grid-area:1/1/2/4;
    display: flex;
    align-items: center;
    padding-left:10px;
    border-bottom:dashed 1px black;
    white-space: pre-line;
}
.modal-front-title-night{
    border-bottom:dashed 1px #dddddd;
}
.modal-front-group-number{
    font-size:10px;
    font-weight: 600;
    text-align: end;
    letter-spacing: 0.2em;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    -webkit-text-orientation: sideways;
    text-orientation: sideways;
    justify-content:flex-end;
    grid-area:6/3/7/4;
    display: flex;
    align-items: center;
    border-bottom:dashed 1px black;
}
.modal-front-group-number-night{
    border-bottom:dashed 1px #dddddd;
}
.modal-front-group-name{
    font-size:24px;
    font-weight:600;
    text-align: left;
    letter-spacing: 0.2em;
    grid-area:2/1/3/3;
    display: flex;
    align-items: center;
    justify-content:flex-start;
    padding-left:10px;
    border-bottom:dashed 1px black;
    border-right:dashed 1px black;
}
.modal-front-group-name-night{
    border-bottom:dashed 1px #dddddd;
    border-right:dashed 1px #dddddd;
}
.modal-front-group-msg{
    font-size:12px;
    font-weight:700;
    text-align: left;
    letter-spacing: 0.2em;
    grid-area:3/1/5/3;
    display: flex;
    align-items: center;
    justify-content:flex-start;
    padding:0 10px;
    line-height: 1.2em;
    -webkit-line-break: normal;
    line-break: normal;
    white-space:pre-line;
    border-bottom:dashed 1px black;
    border-right:dashed 1px black;
}
.modal-front-group-msg-night{
    border-bottom:dashed 1px #dddddd;
    border-right:dashed 1px #dddddd;
}
.modal-front-group-category{
    font-size:10px;
    font-weight:700;
    text-align: end;
    letter-spacing: 0.2em;
    grid-area:3/3/6/4;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    -webkit-text-orientation: sideways;
    text-orientation: sideways;
    display: flex;
    align-items: center;
    justify-content:flex-end;
    border-bottom:dashed 1px black;
}
.modal-front-group-category-night{
    border-bottom:dashed 1px #dddddd;
}
.modal-front-to-behind{
    font-size:12px;
    font-weight:600;
    grid-area:8/2/9/3;
    display: flex;
    align-items: center;
    justify-content:flex-start;
    cursor: pointer;
}
.modal-front-date{
    grid-area:7/3/8/4;
    font-size:10px;
    font-weight:600;
    text-align: end;
    letter-spacing: 0.1em;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    -webkit-text-orientation: sideways;
    text-orientation: sideways;
    display: flex;
    align-items: center;
    justify-content:flex-end;
}
.barcode{
    grid-area:8/1/9/2;
    height:100%;
    width:100%;
    display: flex;
}
.barcode div{
    background-color:black;
    height:100%;
}
.barcode-night div{
    background-color:#dddddd;
}
@media only screen and (min-height:667px) and (max-height:812px){
    .modal-front{
        height:600px;
    }
}
@media  screen and (max-height:667px){
    .modal-front{
        height:500px;
        width:280px;
    }
}
</style>